import React from "react";
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || 'vi';

  return (
    <footer className="bg-[#0A1D0A] text-white px-6 py-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between gap-10 text-sm text-left">
        
        <div className="space-y-6">
          <img src="/images/CTG-logo/Logo2.png" alt="CleanToGreen" className="h-24 w-auto max-w-[260px] md:h-28 md:max-w-[300px]" />
          <div className="space-y-2">
            <p><strong>{t('footer.contact.headquarters_title')}:</strong> {t('footer.contact.headquarters_address')}</p>
            <p><strong>{t('footer.contact.factory_title')}:</strong> {t('footer.contact.factory_address')}</p>
            <p>
              <strong>{t('footer.contact.phone_title')}:</strong>{' '} <a href="tel:+84867003331" className="hover:text-[#DBF8C8] text-white">(+84) 867 003 331</a>{' - '} <a href="tel:+84867003337" className="hover:text-[#DBF8C8] text-white">(+84) 867 003 337</a>
            </p>
            <p><strong>{t('footer.contact.email_title')}:</strong>{' '} <a href="mailto:ctg@cleantogreenctg.com" className="hover:text-[#DBF8C8] text-white">ctg@cleantogreenctg.com</a> </p>
          </div>
        </div>

        <div className="flex flex-col space-y-6">
          <div className="space-y-2">
            <h3 className="font-bold mb-2">{t('footer.categories.title')}</h3>
            <ul className="space-y-1">
              <li>
                <Link to={`/${currentLang}/about-us`} className="hover:text-[#DBF8C8] text-white">
                  {t('footer.categories.about_us')}
                </Link>
              </li>
              {/* --- PHẦN ĐÃ SỬA --- */}
              <li>
                <Link to={`/${currentLang}/products/ctg-01`} className="hover:text-[#DBF8C8] text-white">
                  {t('footer.categories.product_ctg01')}
                </Link>
              </li>
              <li>
                <Link to={`/${currentLang}/products/ctg-02`} className="hover:text-[#DBF8C8] text-white">
                  {t('footer.categories.product_ctg02')}
                </Link>
              </li>
              <li>
                <Link to={`/${currentLang}/products/ctg-ki`} className="hover:text-[#DBF8C8] text-white">
                  {t('footer.categories.product_ki')}
                </Link>
              </li>
              {/* --- KẾT THÚC PHẦN SỬA --- */}
            </ul>
          </div>
          <div className="space-y-2">
            <h3 className="font-semibold mb-2">{t('footer.platforms.title')}</h3>
            <ul className="space-y-1">
              <li><strong>{t('footer.platforms.fanpage')}:</strong> {' '}
                <a
                  href="https://www.facebook.com/cleantogreen.ctg2022"
                  className="hover:text-[#DBF8C8] text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CLEAN to GREEN
                </a>
              </li>
              <li><strong>{t('footer.platforms.tiktok')}:</strong>  {' '}
                <a
                  href="https://www.tiktok.com/@giaiphapctg"
                  className="hover:text-[#DBF8C8] text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @giaiphapctg
                </a>
              </li>
              <li><strong>{t('footer.platforms.shopee')}:</strong>{' '}
                <a
                  href="https://shopee.vn/ctg11052022"
                  className="hover:text-[#DBF8C8] text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  cleantogreenCTG
                </a>
              </li>
              <li><strong>{t('footer.platforms.youtube')}:</strong> {' '}
                <a
                  href="https://www.youtube.com/@CLEANTOGREEN"
                  className="hover:text-[#DBF8C8] text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CLEAN TO GREEN
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-1">
            <h3 className="font-semibold mb-2"><Link to={`/${currentLang}/policy`} className="hover:text-[#DBF8C8] text-white">{t('footer.policies.main_title')}</Link></h3>
            <ul className="space-y-1">
              <li><Link to={`/${currentLang}/terms-conditions`} className="hover:text-[#DBF8C8] text-white">{t('footer.policies.terms')}</Link></li>
              <li><Link to={`/${currentLang}/privacy-policy`} className="hover:text-[#DBF8C8] text-white">{t('footer.policies.privacy')}</Link></li>
              <li><Link to={`/${currentLang}/warranty-return-policy`} className="hover:text-[#DBF8C8] text-white">{t('footer.policies.warranty')}</Link></li>
              <li><Link to={`/${currentLang}/payment-policy`} className="hover:text-[#DBF8C8] text-white">{t('footer.policies.payment')}</Link></li>
              <li><Link to={`/${currentLang}/shipping-policy`} className="hover:text-[#DBF8C8] text-white">{t('footer.policies.shipping')}</Link></li>
            </ul>
          </div>
          <div className="text-xs text-gray-300 pt-4 space-y-1">
            <p>{t('footer.legal.copyright')}</p>
            <p>{t('footer.legal.company_name')}</p>
            <p>{t('footer.legal.license')}</p>
            <p>{t('footer.legal.issued_by')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;